export const USER_SCOPE_CENTRAL = 'central';
export const USER_SCOPE_HOSPITAL = 'hospital';

export const CENTRAL_ROLES = [
  { value: 'superadmin', label: 'Super Admin' },
  { value: 'operator', label: 'Operator' },
];

export const ACTIVE_OPTIONS = [
  { value: 'YES', label: 'Aktif' },
  { value: 'NO', label: 'Nonaktif' },
];
